import React from "react";

const TranslateContext = React.createContext();

export const TranslateProvider = ({ initLocale = "en", children }) => {
    const [locale, setLocale] = React.useState(initLocale);
    const value = { locale, setLocale }
    return <TranslateContext.Provider value={value}>{children}</TranslateContext.Provider>;
};

export const useTranslate = () => {
    return React.useContext(TranslateContext);
}